import { Navigate } from "react-router-dom";
import { useAppSelector } from "../ReduxToolkit/Hooks";
import React from "react";

const RedirectRoute = ({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement | null => {
  const { isAuthenticated, user } = useAppSelector((state) => state.auth);
  const requiresPasswordUpdate = isAuthenticated && user?.first_login === true;
  const updatePasswordPath = `${process.env.PUBLIC_URL}/update-password`;
  const loginPath = `${process.env.PUBLIC_URL}/sign-in`;
  const currentPathIsPasswordUpdate =
    window.location.pathname.includes("/update-password");
  if (!isAuthenticated) {
    return <Navigate to={loginPath} />;
  }
  if (requiresPasswordUpdate && !currentPathIsPasswordUpdate) {
    return <Navigate to={updatePasswordPath} />;
  }
  return <>{children}</>;
};

export default RedirectRoute;
